<template>
  <div class="container py-4" role="status">
    <p v-if="error" class="alert alert-danger">{{ error }}</p>
    <p v-else-if="candidatContactObjId">Ouverture du planning…</p>
    <p v-else>Ouvrez le lien de planning depuis la candidature dans EVA.</p>
  </div>
</template>

<script setup>
/* global defineProps */
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePlanningStore } from '@/store/planningStore';
import PlanningApi from '@/api/PlanningApi';

const props = defineProps({ candidatContactObjId: String });
const router = useRouter();
const store = usePlanningStore();
const error = ref('');

watch(() => props.candidatContactObjId, async (id, previousId, onCleanup) => {
  let active = true;
  onCleanup(() => { active = false; });
  error.value = '';
  if (!id) return;
  try {
    const { data } = await PlanningApi.resolveCandidacyPlanning(store.currentUser.userAccountObjId, id);
    if (!active) return;
    store.setCandidatContactObjId(id);
    const base = `/${data.ofObjId}/${data.userAccountObjId}`;
    await router.replace(data.planningId
      ? { path: `${base}/${data.planningId}/meetings/getList`, query: { editCandidacy: id } }
      : `${base}/planning/getList`);
  } catch (err) {
    if (active && err.response?.status !== 401) {
      error.value = err.response?.data?.message || 'Impossible d’ouvrir le planning. Réessayez ultérieurement.';
    }
  }
}, { immediate: true });
</script>
